module.exports = __webpack_public_path__ + "img/blog-66 (1).233c89f8.jpg";